import React from 'react';
import { ApiContext } from '@deephaven/jsapi-bootstrap';
import { jsx as _jsx } from "react/jsx-runtime";
export function makeApiContextWrapper(dh) {
  return function ApiContextWrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/_jsx(ApiContext.Provider, {
      value: dh,
      children: children
    });
  };
}
export default {
  makeApiContextWrapper
};
//# sourceMappingURL=HookTestUtils.js.map